import { useApp } from 'context/app-context'
import { useCurrentUser } from 'context/current-user-context'
import { useEffect } from 'react'
import * as Sentry from '@sentry/react'

const SentryComponent = () => {
  const { env } = useApp()
  const { id, email } = useCurrentUser()

  useEffect(() => {
    if (typeof Sentry.getClient() !== 'undefined') {
      return
    }

    Sentry.init({
      dsn: env.SENTRY_DSN,
      environment: env.SENTRY_ENVIRONMENT,
      tracesSampleRate: 0.2,
      enabled: env.SENTRY_ENVIRONMENT === 'production',
      // You may want this to be 100% while in development and sample at a lower rate in production
      replaysSessionSampleRate: 1,
      // If the entire session is not sampled, use the below sample rate to sample
      // sessions when an error occurs.
      replaysOnErrorSampleRate: 1,
      integrations: [
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
        }),
        Sentry.replayCanvasIntegration(),
      ],
    })

    return () => {
      Sentry.close()
    }
  }, [])

  useEffect(() => {
    Sentry.setUser({
      email: email,
      id: id,
    })
  }, [email])

  return null
}

export default SentryComponent
